import { IButton } from "./types";

import "./styles.scss";

export const Button = ({ children, size = "medium", ...props }: IButton) => {
  const getClasses = () => {
    const classes = ["button-content", props.theme, `size-${size}`];

    if (props.className) classes.push(props.className);

    return classes.join(" ");
  };

  return (
    <button {...props} className={getClasses()}>
      {children}
    </button>
  );
};
